<template>
  <div class="row">
    <slot></slot>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss">
.row {
  margin-right: -0.75rem;
  margin-left: -0.75rem;
  &::after {
    display: table;
    clear: both;
    content: "";
  }
}
</style>



// WEBPACK FOOTER //
// src/views/components/globals/Row.vue